<template lang="pug">
  section.related
    h4 Más artículos relacionados
    .cont
      router-link.section-link(:to="article.slug", v-for="(article, index) in filteredArticles()" :key="index")
        ArticleItem(:title="article.title", :undertitle="article.undertitle",
        :beforetitle="article.beforetitle",
        :aftertitle="article.aftertitle",
        :img="article.img", :more="true", :alignment="article.alignment")
</template>
<script>
import { mapState } from 'vuex'
import ArticleItem from '@/components/ArticleItem'
export default {
  components: {
    ArticleItem
  },
  mounted(){
    this.filteredArticles()
  },
  computed: {
    ...mapState([
      'articles'
    ]),
  },
  methods: {
    filteredArticles(){
      const filteredArr = this.articles.filter(article => article.slug !== this.$route.params.slug)
      return filteredArr;
    }
  }

}
</script>
<style lang="scss" scoped>
  .related{
    background-color: lighten(#eee9d6, 9%);
    text-align: center;
    padding: 2rem 0;
  }
  h4{
    padding-bottom: 1rem;
  }
  .cont{
    max-width: $overwidth;
    margin-left: auto;
    margin-right: auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;
    @media(max-width: 800px){
      grid-template-columns: repeat(2, 1fr);
    }
  }
  .cont /deep/ {
    .article-item,
    .mask img{
      @media(max-width: 800px){
        max-height: 400px;
      }
    }
    h2.title{
      @include fluid-type(360px,
      1440px,
      18px,
      48px);
      margin-bottom: 0.5rem;
      small{
        @include fluid-type(360px,
        1440px,
        14px,
        23px);
      }
    }
    h4.under{
      @include fluid-type(360px,
      1440px,
      14px,
      18px);
      @media (max-width: 800px){
        display: none;
      }
    }

    .content-title{
      padding: 0;
    }
  }
</style>


